<script>
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('assistantWizard', ['name', 'channel', 'channels']),
  },
  methods: {
    ...mapActions('assistantWizard', ['next', 'updateChannel']),
    changeChannel(e) {
      this.updateChannel(e.target.value);
    },
  },
};
</script>

<template>
  <section class="flex items-center flex-col">
    <div class="flex flex-col w-full flex-1 mb-4">
      <label
        class="text-xl text-center text-slate-900 dark:text-slate-50 mb-8"
        for="language"
      >
        {{ $t('ASSISTANT_MGMT.WIZARD.CHANNEL_LABEL', { name: name }) }}
      </label>
      <select
        id="channel"
        :value="channel"
        class="rounded-md border-2 border-slate-100 text-center w-80 h-10 leading-5"
        @change="changeChannel"
      >
        <option
          v-for="l_channel in channels"
          :key="l_channel.key"
          :disabled="l_channel.disabled"
          :value="l_channel.key"
        >
          {{ l_channel.name }}
          {{
            l_channel.disabled
              ? ` ${$t('ASSISTANT_MGMT.WIZARD.CHANNEL_SOON_LABEL')}`
              : ''
          }}
        </option>
      </select>
    </div>
  </section>
</template>
